<template>




<div>

     <md-dialog class = "modal" :md-active.sync="isWarning">
      <md-dialog-content class="icons-center">
        <i class="material-icons md-48 md-light ">warning</i>
        <h1 class = "modalTitle" >{{this.modalMessage}}</h1>
      </md-dialog-content>
     
    </md-dialog>
     

     <ccic-photo-form ref="CcicPhotoForm" :on-data-refresh="doSearch"/>

     <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>{{photoTag}}</h3>
          <view-image  :src="checkPhoto">
             
          </view-image>
      </md-dialog-content>
     
    </md-dialog>


<md-card  class="searchPanel panelColor">
      <md-card-content >
        <div class="md-layout md-gutter">
          <div v-show="active" class="md-layout-item md-size-20 md-small-size-100">
           
              <div class = "inputBox" v-if="canSearchByTeam">
              <auto-complete-master-data-multiple-select
                  label="CCIC Team"
                  :prepared-options="getCcicTeamSearchOptions"
                  v-model="searchRequest.teams"
              />
            </div>
           
           
        

          </div>

          <div v-show="active" class="md-layout-item md-size-20 md-small-size-100">
            

             <div class = "inputBox" v-if="canSearchByUsers">
              <auto-complete-master-data-multiple-select
                  :prepared-options="getCcicUserSearchOptions"
                  label="Users"
                  v-model="searchRequest.users">
              </auto-complete-master-data-multiple-select>
            </div>


           
           
            
          </div>


          <div v-show="active" class="md-layout-item md-size-20 md-small-size-100">
            

             <div class = "inputBox">
              <datepicker  v-model="searchRequest.punchDate.startDate" >
                <label class="lineH">PunchFrom</label>
              </datepicker>
            </div>


           
            
          </div>


          <div class="md-layout-item md-size-20 md-small-size-100">
            
             <div v-show="active" class = "inputBox">
              <datepicker v-model="searchRequest.punchDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
            
             <div >
              <callingApiCenter :paths="['/api/w/ccic/punch', '/api/w/excel/generate']">
                <md-card-actions   >
                  <md-button @mouseover="mouseOver" @click="doSearch" class="btn-search-ccic-application md-primary md-raised md-lg"><md-icon class = "custButton">search</md-icon></md-button>
                  <md-button @mouseover="mouseOver" @click="clearSearch" class="md-raised "><md-icon class = "custButton">clear</md-icon></md-button>
                   <md-button v-if="items.length > 0" class="md-raised md-wd" @click="doDownloadExcel"><md-icon class = "custButton">cloud_download</md-icon></md-button>
                </md-card-actions>
              </callingApiCenter>
            </div>

           
         


          </div>


          <div v-show="active" class="md-layout-item md-size-20 md-small-size-100">
           
             <div  class = "inputBox">
              <master-data-select label="Sort" group="Sort" v-model="sortStatus"/>
            </div>

            
           
            
          </div>
        
         
         
        </div>
    
      </md-card-content>

    </md-card>

      <pagination :items="items">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w5 headerCenter" v-on:click="sortFunction('user')">User</th>
                    <th class="header-cell w5 headerCenter" v-on:click="sortFunction('date')">Date</th>
                    <th class="header-cell w5 headerCenter " v-on:click="sortFunction('checkIn')">CheckIn</th>
                    <th class="header-cell w5 headerCenter" v-on:click="sortFunction('checkInTime')">Time</th>
                    <th class="header-cell w5 headerCenter" >Photo</th>
                    <th class="header-cell w5 headerCenter " v-on:click="sortFunction('checkOut')">CheckOut</th>
                    <th class="header-cell w5 headerCenter" v-on:click="sortFunction('checkOutTime')">Time</th>
                    <th class="header-cell w5 headerCenter" >Photo</th>
                     <th class="header-cell w5 headerCenter" v-on:click="sortFunction('locationId')">Location</th>
                     <th class="header-cell w12 headerCenter" v-on:click="sortFunction('locationAdd')">Address</th>
                    <th class="header-cell w5 headerCenter" v-on:click="sortFunction('minutes')">Minutes</th>
                    <th class="header-cell w5 headerCenter" v-on:click="sortFunction('hours')">Hours</th>
                    <th class="header-cell w8 headerCenter " v-on:click="sortFunction('teamRemark')">TeamRemark</th>
                     </tr>
                  </thead>
                </table>
              </div>
                <div class="table-body " @scroll="handleScroll">
                <table id="bodytable ">
                  <tbody>
                  <tr :key="item.mainSeq" v-for="item in pageItems" v-on:click = "item.backGroud = !item.backGroud" v-bind:class ="{ selected: item.backGroud }">
                    <td class="body-cell w5 excelBox" >{{item.user}}</td>
                    <td class="body-cell w5 tableW excelBox">{{getDate(item.date)}}</td>
                    <td class="body-cell w5 center excelBox">{{!!(item.checkIn === "T") ? '&#x2713;' : ' '}}</td>
                    <td class="body-cell w5 excelBox">{{item.checkInTime}}</td>
                    <td class="body-cell w5 excelBox">
                         <template v-if="item.checkInLink != null">
                        <a href="" @click.prevent="toggleCheckInPhoto(item)" >photos</a>
                      </template>
                      <template v-else>
                        <span></span>
                      </template>
                    </td>
                    <td class="body-cell w5 center excelBox">{{!!(item.checkOut === "T") ? '&#x2713;' : ' '}}</td>
                    <td class="body-cell w5 excelBox">{{item.checkOutTime}}</td>
                    <td class="body-cell w5 excelBox">
                         <template v-if="item.checkOutLink != null">
                        <a href="" @click.prevent="toggleCheckOutPhoto(item)" >photos</a>
                      </template>
                      <template v-else>
                        <span></span>
                      </template>
                    </td>
                     <td class="body-cell w5 excelBox">{{item.locationId}}</td>
                     <td class="body-cell w12 excelBoxLeft">{{item.locationAdd}}</td>
                    <td class="body-cell w5 excelBox">{{item.minutes}}</td>
                    <td class="body-cell w5 excelBox">{{item.hours}}</td>
                    <td class="body-cell w8 excelBox">{{item.teamRemark}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>




</div>

</template>

<style scoped>

.excelBox {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  
}


.excelBoxLeft {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
  
  
}


.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
    text-align: center;
}

.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 11px 15px 12px 15px;
     margin-top: 10px;

}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 11px 15px 12px 15px;
    margin-top: 10px;
    background-color: #e0eff7;
      
}




.selected {
     background: #c8e6f5;
}

.tableW {
    height: 40px;
}

.center {
    padding-left: 10px;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}


.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}

.custButton {
    margin: 25px;
}



</style>


<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  import api from "../api";
  import parseXls from "../utils/parseXls";
   import NewCcicApplicationForm from "../components/NewCcicApplicationForm.vue";
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import NewCcicContainerForm from "../components/NewCcicContainerForm.vue";
  import DownloadCcicPicturesButton from "../components/DownloadCcicPicturesButton.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";



const getInitSearch = () => ({
   
     punchDate: {
      startDate: null,
      endDate: null,
    },

    teams: [],
    users: [],
    
  });

export default {
    
     data: () => ({
          searchRequest: getInitSearch(),
         
          sortStatus: null,
           items: [
               {
                   date: "05/30/2019",
                   user: "Chris",
                   mainSeq: "05/30/2019_Chris",
                   checkIn: "F",
                   checkInTime: "11:48",
                   checkOut: "T",
                   checkOutTime: "12:00",
                   minutes: 50,
                   hours: 2.5,
                   teamRemark: "LA",
                   backGroud: false,
               },
                {
                   date: "05/31/2019",
                   user: "Chris",
                    mainSeq: "05/31/2019_Chris",
                   checkIn: "T",
                   checkInTime: "10:48",
                   checkOut: "T",
                   checkOutTime: "12:00",
                   minutes: 50,
                   hours: 2.5,
                   teamRemark: "LA",
                   backGroud:false,
               },
               {
                   date: "05/30/2019",
                   user: "Alex",
                   mainSeq: "05/30/2019_Alex",
                   checkIn: "T",
                   checkInTime: "11:48",
                   checkOut: "T",
                   checkOutTime: "19:00",
                   minutes: 50,
                   hours: 2.5,
                   teamRemark: "LA",
                   backGroud: false,
               },
                {
                   date: "05/31/2019",
                   user: "Alex",
                    mainSeq: "05/31/2019_Alex",
                   checkIn: "T",
                   checkInTime: "11:48",
                   checkOut: "T",
                   checkOutTime: "12:00",
                   minutes: 50,
                   hours: 2.9,
                   teamRemark: "LA",
                   backGroud:false,
               },
               {
                   date: "05/30/2019",
                   user: "David",
                   mainSeq: "05/30/2019_David",
                   checkIn: "T",
                   checkInTime: "11:48",
                   checkOut: "T",
                   checkOutTime: "12:00",
                   minutes: 14,
                   hours: 2.5,
                   teamRemark: "LA",
                   backGroud: false,
               },
                {
                   date: "05/31/2019",
                   user: "Chris",
                    mainSeq: "05/31/2019_David",
                   checkIn: "T",
                   checkInTime: "11:48",
                   checkOut: "F",
                   checkOutTime: "12:00",
                   minutes: 50,
                   hours: 2.5,
                   teamRemark: "NJ",
                   backGroud:false,
               },
               {
                   date: "05/30/2019",
                   user: "Anderson",
                    mainSeq: "05/30/2019_Anderson",
                   checkIn: "T",
                   checkInTime: "11:48",
                   checkOut: "T",
                   checkOutTime: "12:00",
                   minutes: 50,
                   hours: 2.5,
                   teamRemark: "LA",
                   backGroud: false,
               },
                {
                   date: "05/31/2019",
                   user: "Anderson",
                    mainSeq: "05/31/2019_Anderson",
                   checkIn: "T",
                   checkInTime: "11:48",
                   checkOut: "T",
                   checkOutTime: "12:00",
                   minutes: 50,
                   hours: 2.5,
                   teamRemark: "LA",
                   backGroud:false,
               },
           ],
       usersToSearch: [],
       selected: false,
       isPictureModalShowing: false,
       isWarning: false,
       checkPhoto: "",
       photoTag: "",
       modalMessage: "",
       active: true,
       
        
    }),

    components: {
     CcicPhotoForm,
     callingApiCenter,
    },
    watch: {
         getPunch(val) {
        this.updateItems(val);
      },

      // eslint-disable-next-line
      "searchRequest.teams"() {
        this.searchRequest.users = [];
      },
     
    },

        computed: {
      ...mapGetters([
        'getCcicApplications',
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getPunch',
      ]),

       canSearchByTeam() {
        return this.getUserProfile.ccicRole === 'CCIC_ROLE_ADMIN' || this.getUserProfile.ccicRole === 'CCIC_ROLE_MANAGER';
      },

       canSearchByUsers() {
        const { ccicRole } = this.getUserProfile;
        return ccicRole === 'CCIC_ROLE_ADMIN' || ccicRole === 'CCIC_ROLE_MANAGER';
      },


       getAllCcicTeamOptions() {
        return this.getMasterDataAsSelectOptionByGroup('CCIC_TEAM');
      },


       getCcicTeamSearchOptions() {
        const { ccicRole, ccicTeams } = this.getUserProfile;
        if (ccicRole === 'CCIC_ROLE_ADMIN') {
          return this.getAllCcicTeamOptions;
        }
        return this.getAllCcicTeamOptions.filter(it => _(ccicTeams)
          .contains(it.id));
      },

         getCcicUserSearchOptions() {
        const ccicUsers = this.usersToSearch;
        const selectedTeams = this.searchRequest.teams;
        if (selectedTeams.length === 0) {
          return ccicUsers;
        }
        return ccicUsers.filter(it => _.intersection(selectedTeams, it.ccicTeams).length > 0);
      },

      

    },

     async mounted() {
        const cachedSearchRequest = this.$store.state.punch.searchRequest;
      if (cachedSearchRequest) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }

           this.updateItems(this.getPunch);
          const { ccicRole, ccicTeams } = this.getUserProfile;
          if (ccicRole !== 'CCIC_ROLE_INSPECTOR') {
                const allCcicUsers = await this.$store.dispatch(
                'getUsersByCategory',
                {
                 category: 'G',
                  dontFilterDisabled: true,
                },
            );
            console.log(JSON.stringify(allCcicUsers));
            if (ccicRole === 'CCIC_ROLE_MANAGER') {
                this.usersToSearch = allCcicUsers.filter(it => _.intersection(it.ccicTeams, ccicTeams).length > 0);
                } else {
                this.usersToSearch = allCcicUsers;
                }
            }

     },

      methods: {

        
          mouseOver: function(){
            this.active = true;
        },

          mouseLeave: function() {
              this.active = !this.active;
          },

          sortFunction(sortFiled){
                const sorted = _(this.items).sortBy(sortFiled);
                console.log(this.sortStatus)
                if (this.sortStatus == "ASCENDING" || this.sortStatus == null)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
                
          },

     updateItems(itemsSource) {
        const items = JSON.parse(JSON.stringify(itemsSource));
        
        items.forEach((it) => {
          it.backGroud = false;
          it.hours = parseFloat(it.hours);
          it.minutes = parseInt(it.minutes);
          
         
        });


        this.items = items
      },


    doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Punch.xls',
          0,
        );
        request.heads = _(request.heads)
          .take(25);
          console.log("header")
          console.log(request.heads)

        request.rows = _(this.items)
          .map(item => [
            item.user,
            item.date,
            item.checkIn == "T" ? '✓' : "",
            item.checkInTime,
             `${item.checkInLink === null ? 0 : 1} photos`,
            item.checkOut == "T" ? '✓' : "",
            item.checkOutTime,
            `${item.checkOutLink === null ? 0 : 1} photos`,
            item.locationId,
            item.locationAdd,
            item.minutes,
            item.hours,
            item.teamRemark,
          ]);

        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },






           handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },


        toggleCheckInPhoto(item) {
        this.isPictureModalShowing = true;
        this.checkPhoto = item.checkInLink
        this.photoTag = "CHECK IN PHOTO"
        
        

      },

      toggleCheckOutPhoto(item) {
        this.isPictureModalShowing = true;
        this.checkPhoto = item.checkOutLink
         this.photoTag = "CHECK OUT PHOTO"
        
        

      },


         getDate(field){
            return moment(field).format('MM-DD-YYYY');
         },

           doSearch() {

        console.log(this.searchRequest.users)
        console.log(this.searchRequest.teams)

        const { users, teams } = this.searchRequest;
        const { ccicRole } = this.getUserProfile;


        this.modalMessage = "";
         if (this.searchRequest.users.length == 0 && this.searchRequest.teams.length == 0)
        {
           // window.alert('Users or Teams must be filled');
            if (ccicRole != "CCIC_ROLE_INSPECTOR")
            {
                this.modalMessage = "TEAMS GROUP OR USERS MUST BE FILLED"
            }
         
          
        }

        if (this.searchRequest.punchDate.startDate == null) {
          //window.alert('Start date must to be filled');
          if (this.modalMessage == "")
          {
                 this.modalMessage = "START DATE MUST TO BE FILLED"
          }
          else
          {
               this.modalMessage = "TEAMS / USERS AND START DATE MUST TO BE FILLED"
          }
        
         
        }

        if (this.modalMessage != "")
        {
            this.isWarning = true

          return;
        }

       
                const requestToSend = JSON.parse(JSON.stringify(this.searchRequest));
                console.log(moment(requestToSend.punchDate.startDate)
           .startOf('d')
           .toDate())
                



                this.searchRequest.usersInTeam = [];
                if (ccicRole === "CCIC_ROLE_INSPECTOR") {
                this.searchRequest.users = [this.getUserProfile.username];
                } else if (users.length === 0 && teams.length > 0) {
                this.searchRequest.usersInTeam = this.usersToSearch
                    .filter(u => _.intersection(teams, u.ccicTeams).length > 0)
                    .map(it => it.id);
                } else if (users.length === 0 && teams.length === 0) {
                if (ccicRole === "CCIC_ROLE_MANAGER") {
                    this.searchRequest.usersInTeam = this.usersToSearch.map(it => it.id);
                }
                }
                console.log(this.searchRequest)
                this.$store.dispatch('loadPunch', this.searchRequest);
               
           },

           clearSearch(){
             _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
          });
        this.$nextTick(() => {
          this.searchRequest = getInitSearch();
          this.mouseLeave();
        });

           },

      },






    
 };
</script>